import React from 'react';

function SupportIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="none"
      viewBox="0 0 24 25"
    >
      <g>
        <path
          fill="#FF8A00"
          d="M19.826 8.967h-.284v-.572c0-3.333-2.741-6.095-6.05-6.095h-2.174c-3.308 0-6.05 2.762-6.05 6.095v.667H5.08C3.945 8.967 3 9.919 3 11.157v3.524c0 1.143.945 2.095 2.08 2.095h1.134c.567 0 .945-.38.945-.952V8.395c0-2.285 1.89-4.19 4.16-4.19h2.173c2.27 0 4.16 1.905 4.16 4.19v8.381c0 1.81-1.418 3.334-3.12 3.524-.283-.762-.945-1.333-1.89-1.333-1.324 0-1.985 1.333-2.08 2.19a.745.745 0 00.19.762c.188.19.472.381.755.381h2.647c3.025 0 5.483-2.476 5.483-5.524v-.095h.283c1.135 0 2.08-.952 2.08-2.095v-3.429c-.095-1.238-1.04-2.19-2.174-2.19z"
        ></path>
      </g>
    </svg>
  );
}

export default SupportIcon;
